// Values mirror dealroom-fe/.env/.env.{development,beta,production}.
// Beta and prod share the "top-legal-prod" Cognito pool.
const configs = {
    dev: {
        gqlEndpoint: 'https://dev-apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_mDKAYOjHb',
            clientId: '1p28i4r0daocn6lbkjpj0vm81',
            oauthDomain: 'https://top-legal-dev.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://dev-outlook.top.legal',
    },
    beta: {
        gqlEndpoint: 'https://beta-apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_tgXUQvdgQ',
            clientId: '17r21a03c5csj0gtno66vqp6q5',
            oauthDomain: 'https://top-legal-prod.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://beta-outlook.top.legal',
    },
    prod: {
        gqlEndpoint: 'https://apollo.top.legal/graphql',
        cognito: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_tgXUQvdgQ',
            clientId: '17r21a03c5csj0gtno66vqp6q5',
            oauthDomain: 'https://top-legal-prod.auth.eu-central-1.amazoncognito.com',
        },
        addinOrigin: 'https://outlook.top.legal',
    },
};
const env = typeof ADDIN_ENV !== 'undefined' ? ADDIN_ENV : 'dev';
export const config = {
    ...configs[env],
    env,
};
